module.exports = __webpack_public_path__ + "img/registerBackground.da417a5a.png";